if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.navButtons = this.querySelectorAll('.product-media-modal__nav');
        this.onKeyNav = this.onKeyNav.bind(this);
        this.navButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.navigate(button.dataset.direction === 'next' ? 1 : -1);
          });
          // Prevent base ModalDialog pointerup handler from closing the modal
          // when the nav arrow is clicked on desktop.
          button.addEventListener('pointerup', (event) => {
            event.stopPropagation();
          });
          button.addEventListener('pointerdown', (event) => {
            event.stopPropagation();
          });
        });
      }

      hide() {
        super.hide();
        document.removeEventListener('keydown', this.onKeyNav);
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        document.addEventListener('keydown', this.onKeyNav);
      }

      onKeyNav(event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.navigate(1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.navigate(-1);
        }
      }

      getMediaItems() {
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return [];
        return Array.from(content.querySelectorAll('[data-media-id]')).filter((element) => {
          return element.parentElement === content;
        });
      }

      navigate(direction) {
        const mediaItems = this.getMediaItems();
        if (mediaItems.length === 0) return;
        const activeIndex = mediaItems.findIndex((element) => element.classList.contains('active'));
        const safeIndex = activeIndex === -1 ? 0 : activeIndex;
        const nextIndex = (safeIndex + direction + mediaItems.length) % mediaItems.length;
        this.setActiveMediaElement(mediaItems[nextIndex]);
      }

      setActiveMediaElement(targetMedia) {
        if (!targetMedia) return;
        const mediaItems = this.getMediaItems();
        mediaItems.forEach((element) => element.classList.remove('active'));
        targetMedia.classList.add('active');

        const template = targetMedia.querySelector('template');
        const templateContent = template ? template.content : null;
        if (
          targetMedia.nodeName === 'DEFERRED-MEDIA' &&
          templateContent &&
          templateContent.querySelector('.js-youtube')
        ) {
          targetMedia.loadContent();
        }

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
        }
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const mediaItems = this.getMediaItems();
        if (mediaItems.length === 0) return;

        const activeMedia = mediaId
          ? mediaItems.find((element) => element.getAttribute('data-media-id') === mediaId) || mediaItems[0]
          : mediaItems[0];

        this.setActiveMediaElement(activeMedia);
        activeMedia.scrollIntoView();
      }
    }
  );
}
